import React from 'react';
import { Calendar } from 'lucide-react';
import { Button } from '../ui/button';

export function DailyMenuSection({ menuItems, onSetDailyMenu }) {
    return (
        <div className="space-y-6" data-testid="daily-menu-section">
            <div className="flex justify-between items-center">
                <div>
                    <h2 className="text-2xl font-bold">Daily Menu</h2>
                    <p className="text-muted-foreground">Set today's specials and available items</p>
                </div>
                <Button onClick={onSetDailyMenu} className="bg-rose-600 hover:bg-rose-700" data-testid="set-daily-menu-btn">
                    <Calendar className="w-4 h-4 mr-2" />
                    Set Daily Menu
                </Button>
            </div>
            
            <div className="bg-rose-50 rounded-xl p-6 border border-rose-200">
                <h3 className="font-semibold text-rose-800 mb-2">How it works</h3>
                <p className="text-rose-700 text-sm">
                    Create a daily menu by selecting items from your menu list. You can also add a chef's special message that will appear on the dining page.
                </p>
            </div>

            <div className="bg-white rounded-xl p-6 border border-stone-200">
                <h3 className="font-semibold mb-4">Available Menu Items</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {menuItems.filter(i => i.is_available).map(item => (
                        <div key={item.id} className="p-3 border border-stone-200 rounded-lg">
                            <p className="font-medium">{item.name}</p>
                            <p className="text-sm text-stone-500">{item.category} • {item.price}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default DailyMenuSection;
